import { Modal, TitleBar } from '@shopify/app-bridge-react';

const IncorrectScanDialog = ({ shopify, focusScanArea }) => {
  return(
    <Modal id="incorrect-modal" variant="large">
      <div className="modal-body">
        <p style={{ 'color': '#8e1f0b' }}>
          The scanned item is not in this order. Do not pick.
        </p>
      </div>
      <TitleBar title="Incorrect Item">
        <button className="incorrect-confirm" variant="primary" onClick={() => shopify.modal.hide('incorrect-modal')}>Confirm</button>
      </TitleBar>
    </Modal>
  )
}

export default IncorrectScanDialog;
